import React from 'react';
import './style.scss';

export const RequestHistoryHeader = () => {
  return (
    <>
      <div className="historyHeader">
        <span className="historyHeader_status">申込状況</span>
        <span className="historyHeader_title">案件名</span>
        <span className="historyHeader_amount">申込（個数／金額）</span>
        <span className="historyHeader_date">申込日</span>
      </div>
    </>
  );
};
